export default __webpack_public_path__ + "static/media/Lovrican-Logo-Icon.77b5f5ee.svg";